angular.module('app.cessao').factory('lastroConsultaFactory', function ($http) {
    var baseUrl = 'api/Lastro';

    return {
        consultarPorPeriodo: function (dtInicio, dtFim, codigoPropostaAN, externo, pagina, tamanhoPagina, callback) {
            var request = {
                parms: [
                    { name: 'DtInicio', value: dtInicio },
                    { name: 'DtTermino', value: dtFim },
                    { name: 'CodigoPropostaAN', value: codigoPropostaAN },
                    { name: 'Externo', value: externo },
                    { name: 'Pagina', value: pagina },
                    { name: 'TamanhoPagina', value: tamanhoPagina }
                ],
                search: ''
            };
            $http.post(appConfig.serviceBase + baseUrl + '/ConsultarPorPeriodo', request)
                .then(function (response) {
                    callback.success(response.data);
                }, function (error) {
                    callback.error(error);
                });
        }
    };
});
